import {GraphQLProvider, createClient} from '@deezer/graphql-client';
import {useMemo} from 'react';
import {useRouter} from 'next/router';
import {config} from '@app/modules/config';
import {getClientAuthInstance} from '@app/modules/auth/client';
import {useAutolog} from '@app/hooks/auth/useAutolog';

export default function PipeProvider({children}: React.PropsWithChildren) {
	const {data} = useAutolog();
	const {locale} = useRouter();
	const gqlClient = useMemo(() => {
		return createClient({
			connectToDevTools: process.env.NODE_ENV === 'development',
			disableOffline: true,
			getLocale: () => locale ?? 'en',
			getToken: async () => data?.jwt ?? '',
			onTokenInvalid: getClientAuthInstance().invalidateCurrentToken,
			uri: config.get('pipeUrl'),
		});
	}, [data, locale]);
	return <GraphQLProvider client={gqlClient}>{children}</GraphQLProvider>;
}
